import { render } from "./LicenseLog.vue?vue&type=template&id=477708a4&scoped=true&ts=true"
import script from "./LicenseLog.vue?vue&type=script&lang=ts"
export * from "./LicenseLog.vue?vue&type=script&lang=ts"

import "./LicenseLog.vue?vue&type=style&index=0&id=477708a4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477708a4"]])

export default __exports__